var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('panel-group',{ref:'panel-group-' + _vm.uid,attrs:{"group-uid":_vm.uid,"show-title":_vm.show_title}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }